import React, { Component } from 'react';
import { FormattedDate } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import base64Generate from '@nubank/www-latam-commons/utils/base64/generate';
import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import Carousel from 'components/Carousel/Carousel';
import { paddingBuilder } from 'styles/themeUtils';

import { List } from './styles/List';
import { StyledTypography } from './styles/MonthEntry';

const timeline = [
  {
    year: 2013,
    3: ['PRESS.TIMELINE.2013.MARCH'],
    5: ['PRESS.TIMELINE.2013.MAY'],
  },
  {
    year: 2014,
    4: ['PRESS.TIMELINE.2014.APRIL'],
    8: ['PRESS.TIMELINE.2014.AUGUST'],
    9: ['PRESS.TIMELINE.2014.SEPTEMBER'],
  },
  {
    year: 2015,
    1: ['PRESS.TIMELINE.2015.JANUARY'],
    3: ['PRESS.TIMELINE.2015.MARCH'],
    5: ['PRESS.TIMELINE.2015.MAY'],
    12: ['PRESS.TIMELINE.2015.DECEMBER.1', 'PRESS.TIMELINE.2015.DECEMBER.2'],
  },
  {
    year: 2016,
    1: ['PRESS.TIMELINE.2016.JANUARY'],
    5: ['PRESS.TIMELINE.2016.MAY.1', 'PRESS.TIMELINE.2016.MAY.2'],
    7: ['PRESS.TIMELINE.2016.JULY'],
    8: ['PRESS.TIMELINE.2016.AUGUST'],
    12: ['PRESS.TIMELINE.2016.DECEMBER'],
  },
  {
    year: 2017,
    1: ['PRESS.TIMELINE.2017.JANUARY'],
    3: ['PRESS.TIMELINE.2017.MARCH'],
    8: ['PRESS.TIMELINE.2017.AUGUST'],
    10: ['PRESS.TIMELINE.2017.OCTOBER'],
    12: ['PRESS.TIMELINE.2017.DECEMBER'],
  },
  {
    year: 2018,
    3: ['PRESS.TIMELINE.2018.MARCH.1', 'PRESS.TIMELINE.2018.MARCH.2'],
    5: ['PRESS.TIMELINE.2018.MAY.1', 'PRESS.TIMELINE.2018.MAY.2'],
  },
  {
    year: 2018,
    6: ['PRESS.TIMELINE.2018.JUNE'],
    9: ['PRESS.TIMELINE.2018.SEPTEMBER'],
    10: ['PRESS.TIMELINE.2018.OCTOBER.1', 'PRESS.TIMELINE.2018.OCTOBER.2'],
    12: ['PRESS.TIMELINE.2018.DECEMBER'],
  },
  {
    year: 2019,
    2: ['PRESS.TIMELINE.2019.FEBRUARY.1', 'PRESS.TIMELINE.2019.FEBRUARY.2'],
    3: ['PRESS.TIMELINE.2019.MARCH.1', 'PRESS.TIMELINE.2019.MARCH.2'],
    5: ['PRESS.TIMELINE.2019.MAY.1', 'PRESS.TIMELINE.2019.MAY.2'],
  },
  {
    year: 2019,
    6: ['PRESS.TIMELINE.2019.JUNE'],
    7: ['PRESS.TIMELINE.2019.JULY.1', 'PRESS.TIMELINE.2019.JULY.2'],
  },
  {
    year: 2020,
    1: ['PRESS.TIMELINE.2020.JANUARY'],
    3: ['PRESS.TIMELINE.2020.MARCH'],
  },
];

class SectionTimeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = currentStep => {
    this.setState(() => ({
      currentStep,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (
      <>
        <Section
          backgroundColor="primary.default"
          minHeight="auto"
        >
          <Block blockWidth="100%">
            <Typography
              color="white"
              colorVariant="dark"
              variant="title"
              intlKey="PRESS.TIMELINE.TITLE"
              intlValues={{ br: <br /> }}
            />
          </Block>
        </Section>

        <Section backgroundColor="primary.default" minHeight="auto">
          <Block
            blockWidth="40%"
            justifyContent="start"
            padding={{
              default: paddingBuilder.vertical(0),
            }}
          >
            <Carousel
              controlsProps={{
                variant: 'basic',
                styleVariant: 'white',
              }}
              currentStep={currentStep}
              onStepChanged={this.handleChangeCarouselStep}
            >
              {timeline.map(({ year }) => (
                <Typography
                  key={`year-${base64Generate()}`}
                  color="white"
                  colorVariant="dark"
                  tag="h2"
                  variant="supertitle"
                >
                  {year}
                </Typography>
              ))}
            </Carousel>
          </Block>

          <Block blockWidth="60%">
            <Carousel
              currentStep={currentStep}
              onStepChanged={this.handleChangeCarouselStep}
              showControls={false}
            >
              {timeline.map(({ year, ...months }) => (
                <List key={`year-${base64Generate()}`}>
                  {Object.keys(months).map(month => (
                    <li key={`${year}-${month}`}>
                      <StyledTypography
                        color="white"
                        colorVariant="dark"
                        variant="subtitle"
                        tag="h3"
                        gutterBottom={1}
                      >
                        <FormattedDate
                          month="long"
                          value={new Date(year, month - 1, '2')}
                        />
                      </StyledTypography>

                      {months[month].map(notice => (
                        <Typography
                          key={notice}
                          color="white"
                          colorVariant="dark"
                          gutterBottom={1}
                          intlKey={notice}
                        />
                      ))}
                    </li>
                  ))}
                </List>
              ))}
            </Carousel>
          </Block>
        </Section>
      </>
    );
  }
}

export default React.memo(SectionTimeline);
